
import { X } from 'lucide-react';
import TopNavbar from '../components/TopNavbar';
import Learning_us_states from './learning_us_states';
import { Outlet } from 'react-router-dom';
const Learning = ( ) => {
 
  
    return (
        <div>
        <TopNavbar />
        <Learning_us_states /> 

        <Outlet />
           
    </div>
  );
};
 
export default Learning;